export type TestResultsDestinationInjectedProviderProps = {
  readableWorksheets: Array<any>;
  imports: Array<any>;
};

export enum AssociatedTestType {
  Imported = 0,
  Measured = 1,
  External = 2,
  AutoImported = 3,
}
